import { Link } from 'react-router-dom';
import { Link as MUILink } from '@mui/material';
import { Auth } from './auth-form';
import { useLogin } from './login.hook';

export const Login = () => {
  const { login, error } = useLogin();

  return (
    <>
      <Auth
        submitLabel="Login"
        onSubmit={({ email, password }) => {
          login({ email, password });
        }}
        error={error ? 'Credentials are not valid.' : ''}
      >
        <Link to={'/signup'} style={{ alignSelf: 'center' }}>
          <MUILink>Signup</MUILink>
        </Link>
      </Auth>
    </>
  );
};
